export var BeaconType;
(function (BeaconType) {
    BeaconType["Default"] = "default";
    BeaconType["Tag"] = "tag";
})(BeaconType || (BeaconType = {}));
